import { StyledGridToolbarQuickFilter } from "components/templates/dataGridTable/styles";
import React from "react";
import translations from "translations";

interface Props {}

const UnitsQuickFilter: React.FC<Props> = () => {
  return (
    <>
      <StyledGridToolbarQuickFilter
        quickFilterParser={(searchText) => (searchText ? [searchText] : [])}
        variant="outlined"
        placeholder={translations.globals.table.searchTableDefault}
        debounceMs={500}
      />
    </>
  );
};

export default UnitsQuickFilter;
